import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "leitner" }
const _hoisted_2 = { class: "leitner__inner" }
const _hoisted_3 = {
  class: "leitner__stats",
  "aria-label": "خلاصه پیشرفت"
}
const _hoisted_4 = { class: "leitner__stat" }
const _hoisted_5 = { class: "leitner__stat" }
const _hoisted_6 = { class: "leitner__stat" }
const _hoisted_7 = {
  class: "leitner__boxes",
  "aria-label": "جعبه‌های لایتنر"
}
const _hoisted_8 = { class: "leitner__box-label" }
const _hoisted_9 = { class: "leitner__box-count" }
const _hoisted_10 = { class: "leitner__box-hint" }
const _hoisted_11 = {
  class: "leitner__box-bar",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "leitner__actions" }
const _hoisted_13 = ["disabled"]

import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { getLeitnerOverview } from "@/api/leitner";
import { handleError } from "@/services/errorHandler";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import type { LeitnerOverview } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'LeitnerBox',
  setup(__props) {

const router = useRouter();
const overview = ref<LeitnerOverview | null>(null);
const loading = ref(true);
const starting = ref(false);
const errorMessage = ref<string | null>(null);

const maxBoxCount = computed(() =>
  Math.max(1, ...(overview.value?.boxes.map((b) => b.count) || [1]))
);

function toPersianDigits(value: number | string): string {
  return String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);
}

function boxHint(box: number): string {
  const hints: Record<number, string> = {
    1: "هر روز",
    2: "هر ۲ روز",
    3: "هر ۴ روز",
    4: "هر ۷ روز",
    5: "هر ۱۴ روز",
  };
  return hints[box] || "";
}

function boxBarWidth(count: number): string {
  return `${Math.round((count / maxBoxCount.value) * 100)}%`;
}

async function load() {
  loading.value = true;
  errorMessage.value = null;
  try {
    overview.value = await getLeitnerOverview();
  } catch (e) {
    errorMessage.value = handleError(e, "LeitnerBox.load");
  } finally {
    loading.value = false;
  }
}

async function startReview() {
  starting.value = true;
  try {
    await router.push("/dashboard/leitner/review");
  } finally {
    starting.value = false;
  }
}

function goBack() {
  if (window.history.state && window.history.state.back) {
    router.back();
  } else {
    router.push("/dashboard");
  }
}

onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "leitner__back",
        "aria-label": "بازگشت",
        onClick: goBack
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          viewBox: "0 0 24 24",
          width: "20",
          height: "20",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "aria-hidden": "true"
        }, [
          _createElementVNode("path", {
            d: "M5 12H19",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M13 6l6 6-6 6",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1),
        _createElementVNode("span", null, "بازگشت", -1)
      ]))]),
      _cache[5] || (_cache[5] = _createElementVNode("header", { class: "leitner__header" }, [
        _createElementVNode("p", { class: "leitner__eyebrow" }, "جعبه لایتنر"),
        _createElementVNode("h1", { class: "leitner__title" }, "تمرین واژگان با مرور فاصله‌دار"),
        _createElementVNode("p", { class: "leitner__subtitle" }, " واژه‌هات رو با دکمه شناور «لایتنر» اضافه کن. درست‌ها به جعبه بعدی می‌روند؛ اشتباه‌ها به جعبه ۱ برمی‌گردند. ")
      ], -1)),
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, {
            key: 0,
            message: "در حال آماده‌سازی جعبه‌ها..."
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 1,
              message: errorMessage.value,
              onRetry: load
            }, null, 8, ["message"]))
          : (overview.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("section", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("strong", null, _toDisplayString(toPersianDigits(overview.value.due_count)), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("span", null, "آماده مرور", -1))
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("strong", null, _toDisplayString(toPersianDigits(overview.value.total_cards)), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "کل کارت‌ها", -1))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("strong", null, _toDisplayString(toPersianDigits(overview.value.mastered_count)), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", null, "جعبه ۵", -1))
                  ])
                ]),
                _createElementVNode("section", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overview.value.boxes, (box) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: box.box,
                      class: _normalizeClass(["leitner__box", `leitner__box--${box.box}`])
                    }, [
                      _createElementVNode("span", _hoisted_8, "جعبه " + _toDisplayString(toPersianDigits(box.box)), 1),
                      _createElementVNode("strong", _hoisted_9, _toDisplayString(toPersianDigits(box.count)), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(boxHint(box.box)), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ width: boxBarWidth(box.count) })
                        }, null, 4)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "leitner__cta",
                    disabled: overview.value.due_count === 0 || starting.value,
                    onClick: startReview
                  }, _toDisplayString(overview.value.due_count > 0 ? "شروع مرور امروز" : "فعلاً کارتی برای مرور نیست"), 9, _hoisted_13),
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "leitner__tip" }, " هنوز واژه‌ای نداری؟ از دکمه شناور «لایتنر» در گوشه صفحه، کارت جدید بساز. فاصله مرور: جعبه ۱ → روزانه، ۲ → ۲ روز، ۳ → ۴ روز، ۴ → ۷ روز، ۵ → ۱۴ روز ", -1))
                ])
              ], 64))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})